import * as PIXI from "pixi.js";
//@ts-ignore
window.PIXI = PIXI;
import "pixi-spine";
import "pixi.js-legacy";
import "lodash";
import "gsap";
import "./styles/game.css";
import "../../vendor_core/core/static/styles/main.css";
import { utils as PixiUtils } from "pixi.js";
import EventEmitter = PixiUtils.EventEmitter;
import App from "../../vendor_core/core/src/App";
import InstanceFactory from "../../vendor_core/core/src/factories/InstanceFactory";
import GameFactory from "./BURGameFactory";
import MessagePopup from "../../vendor_core/core/src/ui/popups/MessagePopup";
import ErrorPopup from "../../vendor_core/core/src/ui/popups/ErrorPopup";
import InsufficientPopup from "../../vendor_core/src/ui/popups/InsufficientPopup";
import UIController from "../../vendor_core/core/src/ui/UIController";
import BURFeatureModel from "./models/BURFeatureModel";
import { UIModes } from "../../vendor_core/core/src/ui/UIStates";
import VendorWrapper from "../../vendor_core/src/controllers/VendorWrapper";

//   *COMMANDS*
import { Commands } from "../../vendor_core/core/src/commands/CommandEnum";
import CommandManager from "../../vendor_core/core/src/commands/CommandManager";
import * as GameCommands from "../../vendor_core/core/src/commands/GameCommands";
import * as VendorCommands from "../../vendor_core/src/commands/VendorCommands";
import { VendorCommandsEnum } from "../../vendor_core/src/commands/VendorCommandsEnum";

//   *MODELS*
import VendorModel from "../../vendor_core/src/model/VendorModel";
import betModel from "../../vendor_core/core/src/model/BetModel";
import SpinModel from "../../vendor_core/core/src/model/SpinModel";
import ErrorModel from "../../vendor_core/core/src/model/ErrorModel";
import AutoplayModel from "../../vendor_core/core/src/model/AutoplayModel";
import PromotionalFreeGamesModel from "../../vendor_core/src/model/PromotionalFreeGamesModel";
import GameModel from "../../vendor_core/core/src/model/GameModel";

//   *CONDITIONS*
import { RealityCheckState } from "../../vendor_core/core/src/states/RealityCheckState";
import VendorFinishState from "../../vendor_core/src/states/VendorFinishState";
import { HasRealityCheckCondition } from "../../vendor_core/core/src/states/conditions/RealityCheckConditions";
import AlwaysTrueCondition from "../../vendor_core/core/src/states/conditions/AlwaysTrueCondition";
import HasRandomSymbolsCondition from "../../vendor_core/core/src/states/conditions/HasRandomSymbolsCondition";
import CombinedCondition, {
    ConditionCombinationType
} from "../../vendor_core/core/src/states/conditions/CombinedCondition";
import { BURFreeSpinsWonCondition } from "./conditions/BURFreeSpinsWonCondition";
import { BURHasFreeSpinsCondition } from "./conditions/BURHasFreeSpinsCondition";
import { BURHasBigWinCondition } from "./conditions/BURHasBigWinCondition";
import { BURHasSmallWinCondition } from "./conditions/BURHasSmallWinCondition";
import { BURHasMysterySymbolsCondition } from "./conditions/BURHasMysterySymbolsCondition";
import { BURHasCascadeCondition } from "./conditions/BURHasCascadeCondition";
import { BURHasRandomWildsFeatureCondition } from "./conditions/BURHasRandomWildsFeatureCondition";
import { BURHasEnergyChargeFeatureCondition } from "./conditions/BURHasEnergyChargeFeatureCondition";
import { BURHasBlueRespinCondition } from "./conditions/BURHasBlueRespinCondition";
import { BURHasRecoverFeatureCondition } from "./conditions/BURHasRecoverFeatureCondition";
import { BURHasRecoverFreeSpinsCondition } from "./conditions/BURHasRecoverFreeSpinsCondition";
import { BURHasJackpotsProgressCondition } from "./conditions/BURHasJackpotsProgressCondition";
import { HasAutoplayCondition } from "../../vendor_core/core/src/states/conditions/HasAutoplayCondition";
import { IsInFreeSpinsCondition } from "../../vendor_core/core/src/states/conditions/IsInFreeSpinsCondition";
import HasJackpotsFeatureCondition from "../../vendor_core/src/states/conditions/HasJackpotsFeatureCondition";
import { HasErrorCondition } from "../../vendor_core/core/src/states/conditions/HasErrorCondition";
import HasJackpotWonCondition from "../../vendor_core/src/states/conditions/HasJackpotWonCondition";
import HasRecovery from "../../vendor_core/src/states/conditions/HasRecovery";

//   *STATES*
import stateMachine from "../../vendor_core/core/src/states/StateMachine";
import LoopLinesState from "../../vendor_core/core/src/states/LoopLinesState";
import { IStatesConfigSchema } from "../../vendor_core/core/src/states/State";
import ErrorState from "../../vendor_core/src/states/ErrorState";
import BURPreloaderState from "./states/BURPreloaderState";
import JackpotWinState from "../../vendor_core/src/states/JackpotWinState";
import EnterRecoverState from "../../vendor_core/src/states/EnterRecoverState";
import BURBigWinState from "./states/BURBigWinState";
import AuthorizationState from "../../vendor_core/src/states/AuthorizationState";
import VendorSpinGetResultState from "../../vendor_core/src/states/VendorSpinGetResultState";
import SpinEndState from "../../vendor_core/core/src/states/SpinEndState";
import BURShowWinState from "../src/states/BURShowWinState";
import StartFreeSpinsState from "../../vendor_core/core/src/states/StartFreeSpinsState";
import BURExitFreeSpinsState from "../src/states/BURExitFreeSpinsState";
import BURTransformSymbolsState from "../src/states/BURTransformSymbolsState";
import BURPlayCascadeState from "../src/states/BURPlayCascadeState";
import BURPlayRandomWildsState from "../src/states/BURPlayRandomWildsState";
import BURPlayEnergyChargeState from "../src/states/BURPlayEnergyChargeState";
import BURRecoverFeatureState from "../src/states/BURRecoverFeatureState";
import BURRecoverFreeSpinsState from "../src/states/BURRecoverFreeSpinsState";
import BURPlayBlueRespinState from "../src/states/BURPlayBlueRespinState";
import BURFreeSpinStartState from "./states/BURFreeSpinStartState";
import BURJackpotsProgressState from "./states/BURJackpotsProgressState";
import BURRecoverSpinStartState from "./states/BURRecoverSpinStartState";
import BUREnterFreespinState from "../src/states/BUREnterFreespinState";
import BURIdleState from "./states/BURIdleState";
import BURVendorSpinStartState from "./states/BURVendorSpinStartState";
import BURSpinResultState from "./states/BURSpinResultState";

//   *UTILS*
import Assets from "../../vendor_core/core/src/utils/Assets";
import GameLoader from "../../vendor_core/core/src/utils/GameLoader";
import Layout from "../../vendor_core/core/src/utils/Layout";
import SoundController from "../../vendor_core/core/src/utils/SoundController";
import SymbolMap from "../../vendor_core/core/src/utils/SymbolMap";
import Utils from "../../vendor_core/core/src/utils/Utils";
import ViewManager from "../../vendor_core/core/src/utils/ViewManager";
import DebugMenu from "../../vendor_core/core/src/utils/DebugMenu";
import ConsoleUtil from "../../vendor_core/core/src/utils/ConsoleUtil";

//   *CONFIGS*
import ConfigManager from "../../vendor_core/core/src/managers/ConfigManager";
import * as asset_config from "../configs/asset-config-main.json";
import * as debug_config from "../configs/debug-config.json";
import * as game_config from "../configs/game-config.json";
import * as state_config from "../configs/state-config.json";
import SettingsConfig from "../configs/SettingConfig";
import BetConfig from "../configs/BetConfig";
import VendorLocalConfig from "../../vendor_core/src/vendorConfigs/VendorLocalConfig";
import GameGeneralConfig from "../configs/GameGeneralConfig";
import ErrorConfig from "../configs/ErrorConfig";
import SymbolSpineAnimationConfig from "../configs/SymbolSpineAnimationsConfig";
import SpineAnimationsConfig from "../configs/SpineAnimationsConfig";
import SpineWinSymbolViewConfig from "../configs/SpineWinSymbolViewConfig";
import ReelsConfig from "../configs/ReelsConfig";

//   *REQUESTS*
import CommManager from "../../vendor_core/core/src/controllers/CommManager";
import requestRegister from "../../vendor_core/core/src/server/requests/RequestRegister";
import GetUserRequest from "../../vendor_core/src/server/requests/GetUserRequest";
import GetSessionRequest from "../../vendor_core/src/server/requests/GetSessionRequest";
import GetGameParametersRequest from "../../vendor_core/src/server/requests/GetGameParametersRequest";
import OpenPlayRequest from "../../vendor_core/src/server/requests/OpenPlayRequest";
import PlaceBetRequest from "../../vendor_core/src/server/requests/PlaceBetRequest";
import GetBetResultRequest from "../../vendor_core/src/server/requests/GetBetResultRequest";
import SettlePlayRequest from "../../vendor_core/src/server/requests/SettlePlayRequest";
import ClosePlayRequest from "../../vendor_core/src/server/requests/ClosePlayRequest";
import SaveGameSettingsRequest from "../../vendor_core/src/server/requests/SaveGameSettingsRequest";
import LoadGameSettingsRequest from "../../vendor_core/src/server/requests/LoadGameSettingsRequest";
import ClearGameSettingsRequest from "../../vendor_core/src/server/requests/ClearGameSettingsRequest";
import GetJackpotsRequest from "../../vendor_core/src/server/requests/GetJackpotsRequest";
import GetBalanceRequest from "../../vendor_core/src/server/requests/GetBalanceRequest";

//   *PARSERS*
import ErrorDataParser from "../../vendor_core/src/server/parsers/errorDataParser";
import AuthorisationDataParser from "../../vendor_core/src/server/parsers/AuthorisationDataParser";
import SessionDataParser from "../../vendor_core/src/server/parsers/SessionDataParser";
import UrlParametersParser from "../../vendor_core/src/server/parsers/UrlParametersParser";
import VendorDataParser from "../../vendor_core/src/server/parsers/VendorDataParser";
import BalanceDataParser from "../../vendor_core/src/server/parsers/BalanceDataParser";
import PromotionalFreeGamesDataParser from "../../vendor_core/src/server/parsers/PromotionalFreeGamesDataParser";
import RefreshReelDataParser from "../../vendor_core/src/server/parsers/RefreshReelDataParser";
import BURSpinDataParser from "./server/parsers/BURSpinDataParser";
import BURInitDataParser from "./server/parsers/BURInitDataParser";
import BURSessionDataParser from "./server/parsers/BURSessionDataParser";
import BURBetDataParser from "./server/parsers/BURBetDataParser";
import BURGameDataParser from "./server/parsers/BURGameDataParser";
import BURAutoplayDataParser from "./server/parsers/BURAutoplayDataParser";
import HTMLPopupsManager from "../../vendor_core/core/src/utils/HTMLPopupsManager";
import BURHistoryHTMLPopup from "./view/history/BURHistoryHTMLPopup";
import GetHistoryRequest from "../../vendor_core/src/server/requests/GetHistoryRequest";
import GameLocalConfig from "../configs/GameLocalConfig";
import TokenDataParser from "../../vendor_core/src/server/parsers/TokenDataParser";
import gsap from "gsap";
import { PixiPlugin } from "gsap/all";

declare const DEBUG: boolean;
const urlParams: any = {};

location.search
    .substr(1)
    .split("&")
    .forEach((item) => {
        const tmp = item.split("=");
        if (tmp[0].length > 0) {
            urlParams[tmp[0]] = decodeURIComponent(tmp[1]);
        }
    });
ConsoleUtil.log("version : ", urlParams.version);

const link = document.createElement("link");

link.rel = "stylesheet";
link.href = "./styles/main.css?version=" + urlParams.version;
document.getElementsByTagName("head")[0].appendChild(link);

// TODO THIS NEEDS A LOT OF REFACTORING
const start = (params) => {
    const gameConfig = params.config;
    // GameLoader.loader.baseUrl = "";

    gsap.registerPlugin(PixiPlugin);

    ConfigManager.registerConfigs([
        SymbolSpineAnimationConfig,
        SpineWinSymbolViewConfig,
        SpineAnimationsConfig,
        SettingsConfig,
        BetConfig,
        GameLocalConfig,
        VendorLocalConfig,
        GameGeneralConfig,
        ErrorConfig,
        ReelsConfig
    ]);

    GameModel.parseUrlParams(urlParams, gameConfig);

    GameModel.hasRealityCheck = false;
    GameLoader.loadFonts(gameConfig);
    // GameModel.apiConfig = loader.resources.apiConfig.data;
    // wait for fonts to load
    // window.onload = () => {
    const configs = GameModel.isMobile()
        ? asset_config.asset_configs.mobile
        : asset_config.asset_configs.desktop;
    GameLoader.loadConfig(configs, (loader) => {
        GameModel.apiConfig = loader.resources.apiConfig.data;
        GameLoader.loadConfig(
            loader.resources.asset_config.data.layoutConfigurations,
            (loader) => {
                const deviceWidth = Math.max(
                    window.screen.width,
                    window.screen.height
                );
                const START_WIDTH = Math.min(
                    deviceWidth,
                    loader.resources.layoutConfig.data.settings.nativeWidth
                );
                // const START_HEIGHT = loader.resources.layoutConfig.data.settings.nativeHeight;
                //  const START_WIDTH = Math.max(window.screen.width, window.screen.height);
                const START_HEIGHT = (START_WIDTH * 9) / 16;
                ConsoleUtil.log(START_WIDTH, START_HEIGHT);
                CommManager.setComm();
                initDefaultCommads();
                registerRequests();
                registerParsers();
                GameModel.update(urlParams);
                InstanceFactory.init(new GameFactory());
                HTMLPopupsManager.init(
                    document.getElementById("content"),
                    BURHistoryHTMLPopup
                );

                const app = new App(
                    loader.resources.layoutConfig.data.settings
                );
                Layout.init(START_WIDTH, START_HEIGHT);
                Utils.serialize(gameConfig, GameModel);
                SymbolMap.init(GameModel.gameConfig.symbolResponseMap);
                SoundController.init();
                App.version = urlParams.version;
                App.assets = new Assets();
                App.utils = new Utils();
                App.dispatcher = new EventEmitter();

                if (DEBUG) {
                    window["ViewManager"] = ViewManager;
                    window["App"] = App;
                    window["Layout"] = Layout;
                    window["UI"] = UIController;
                } else {
                    delete globalThis.__PIXI_APP__;
                }

                const mainLayoutData = loader.resources.layoutConfig.data;
                const secondaryData = loader.resources.secondaryLayoutConfig
                    ? loader.resources.secondaryLayoutConfig.data
                    : null;
                ViewManager.init(
                    mainLayoutData,
                    loader.resources.layerMap.data,
                    secondaryData
                );
                VendorWrapper.init(
                    START_WIDTH,
                    START_HEIGHT,
                    GameModel.gameConfig.hasJackpotsFeature
                );
                window.onresize = VendorWrapper.onResize.bind(VendorWrapper);
                document
                    .getElementById(params.config.container_name)
                    .appendChild(app.view);
                VendorWrapper.onResize();
                registerStates();
                setUpUIComponents();
                if (DEBUG) {
                    createDebugMenu();
                }

                function registerRequests() {
                    requestRegister.add("login", new GetUserRequest());
                    requestRegister.add(
                        "createSession",
                        new GetSessionRequest()
                    );
                    requestRegister.add(
                        "refreshRequest",
                        new GetGameParametersRequest()
                    );
                    requestRegister.add(
                        "getLastPlayHistory",
                        new GetHistoryRequest()
                    );

                    requestRegister.add("playRequest", new OpenPlayRequest());
                    requestRegister.add("placeBet", new PlaceBetRequest());
                    requestRegister.add("getResult", new GetBetResultRequest());
                    requestRegister.add("settlePlay", new SettlePlayRequest());
                    requestRegister.add("closePlay", new ClosePlayRequest());
                    requestRegister.add(
                        "saveState",
                        new SaveGameSettingsRequest()
                    );
                    requestRegister.add(
                        "loadSavedState",
                        new LoadGameSettingsRequest()
                    );
                    requestRegister.add(
                        "clearState",
                        new ClearGameSettingsRequest()
                    );
                    requestRegister.add(
                        "jackpotsUpdate",
                        new GetJackpotsRequest()
                    );
                    requestRegister.add("getBalance", new GetBalanceRequest());
                }

                function registerParsers() {
                    GameModel.registerParser(new BURGameDataParser());
                    GameModel.registerParser(new AuthorisationDataParser());
                    GameModel.registerParser(new SessionDataParser());
                    GameModel.registerParser(new TokenDataParser());
                    GameModel.registerParser(new UrlParametersParser());
                    betModel.registerParser(new BURBetDataParser());
                    VendorModel.registerParser(new VendorDataParser());
                    betModel.registerParser(new BalanceDataParser());
                    AutoplayModel.registerParser(new BURAutoplayDataParser());
                    SpinModel.registerParser(new BURSpinDataParser());
                    GameModel.registerParser(new BURInitDataParser());
                    GameModel.registerParser(new BURSessionDataParser());
                    SpinModel.registerParser(new RefreshReelDataParser());
                    ErrorModel.registerParser(new ErrorDataParser());

                    PromotionalFreeGamesModel.registerParser(
                        new PromotionalFreeGamesDataParser()
                    );
                }

                function createDebugMenu() {
                    const debugMenu = new DebugMenu(
                        document.getElementById("content")
                    );
                    debugMenu.addDebugInput("Custom");
                    Object.keys(debug_config).forEach((key) => {
                        const element = debug_config[key];
                        if ("name" in element && "data" in element) {
                            debugMenu.addDebugCase(
                                element.name,
                                element.data,
                                false
                            );
                        }
                    });
                    debugMenu.menu.style.zIndex =
                        params.config.canvas_zIndex + 1;
                }

                function registerStates() {
                    stateMachine.registerState(
                        "init",
                        new AuthorizationState(stateMachine)
                    );
                    stateMachine.registerState(
                        "preload",
                        new BURPreloaderState(stateMachine)
                    );
                    stateMachine.registerState(
                        "idle",
                        new BURIdleState(stateMachine)
                    );
                    stateMachine.registerState(
                        "spin",
                        new BURVendorSpinStartState(stateMachine)
                    );
                    stateMachine.registerState(
                        "spin_result",
                        new BURSpinResultState(stateMachine)
                    );
                    stateMachine.registerState(
                        "spin_end",
                        new SpinEndState(stateMachine)
                    );
                    stateMachine.registerState(
                        "small_win",
                        new BURShowWinState(stateMachine)
                    );
                    stateMachine.registerState(
                        "big_win",
                        new BURBigWinState(stateMachine)
                    );
                    stateMachine.registerState(
                        "wins_shown",
                        new LoopLinesState(stateMachine)
                    );
                    stateMachine.registerState(
                        "jackpot_win",
                        new JackpotWinState(stateMachine)
                    );
                    stateMachine.registerState(
                        "error",
                        new ErrorState(stateMachine)
                    );
                    stateMachine.registerState(
                        "get_spin_result",
                        new VendorSpinGetResultState(stateMachine)
                    );
                    stateMachine.registerState(
                        "reality_check",
                        new RealityCheckState(stateMachine)
                    );
                    stateMachine.registerState(
                        "finish",
                        new VendorFinishState(stateMachine)
                    );
                    stateMachine.registerState(
                        "recover_spin",
                        new BURRecoverSpinStartState(stateMachine)
                    );
                    stateMachine.registerState(
                        "recover",
                        new EnterRecoverState(stateMachine)
                    );
                    stateMachine.registerState(
                        "enter_freespins",
                        new BUREnterFreespinState(stateMachine)
                    );
                    stateMachine.registerState(
                        "exit_freespins",
                        new BURExitFreeSpinsState(stateMachine)
                    );
                    stateMachine.registerState(
                        "fs_start",
                        new StartFreeSpinsState(stateMachine)
                    );
                    stateMachine.registerState(
                        "transform_symbols",
                        new BURTransformSymbolsState(stateMachine)
                    );
                    stateMachine.registerState(
                        "play_cascade",
                        new BURPlayCascadeState(stateMachine)
                    );
                    stateMachine.registerState(
                        "play_random_wilds_feature",
                        new BURPlayRandomWildsState(stateMachine)
                    );
                    stateMachine.registerState(
                        "play_energy_charge_feature",
                        new BURPlayEnergyChargeState(stateMachine)
                    );
                    stateMachine.registerState(
                        "play_blue_respin",
                        new BURPlayBlueRespinState(stateMachine)
                    );
                    stateMachine.registerState(
                        "free_spin_start",
                        new BURFreeSpinStartState(stateMachine)
                    );
                    stateMachine.registerState(
                        "play_jackpots_progress",
                        new BURJackpotsProgressState(stateMachine)
                    );
                    stateMachine.registerState(
                        "recover_base_game_feature",
                        new BURRecoverFeatureState(stateMachine)
                    );
                    stateMachine.registerState(
                        "recover_free_spins",
                        new BURRecoverFreeSpinsState(stateMachine)
                    );

                    //** CONDITIONS **/
                    stateMachine.registerCondition(
                        "default",
                        new AlwaysTrueCondition()
                    );
                    stateMachine.registerCondition(
                        "hasMysterySymbols",
                        new BURHasMysterySymbolsCondition()
                    );
                    stateMachine.registerCondition(
                        "hasCascades",
                        new BURHasCascadeCondition()
                    );
                    stateMachine.registerCondition(
                        "hasRandomWildsFeature",
                        new BURHasRandomWildsFeatureCondition()
                    );
                    stateMachine.registerCondition(
                        "hasEnergyChargeFeature",
                        new BURHasEnergyChargeFeatureCondition()
                    );
                    stateMachine.registerCondition(
                        "hasBlueRespin",
                        new BURHasBlueRespinCondition()
                    );
                    stateMachine.registerCondition(
                        "hasBigWin",
                        new BURHasBigWinCondition()
                    );
                    stateMachine.registerCondition(
                        "hasSmallWin",
                        new BURHasSmallWinCondition()
                    );
                    stateMachine.registerCondition(
                        "hasAutoplay",
                        new HasAutoplayCondition()
                    );
                    stateMachine.registerCondition(
                        "freespinsWon",
                        new BURFreeSpinsWonCondition()
                    );
                    stateMachine.registerCondition(
                        "inFreespins",
                        new IsInFreeSpinsCondition()
                    );
                    stateMachine.registerCondition(
                        "hasError",
                        new HasErrorCondition()
                    );
                    stateMachine.registerCondition(
                        "has_jackpot_won",
                        new HasJackpotWonCondition()
                    );
                    stateMachine.registerCondition(
                        "hasRealityCheck",
                        new HasRealityCheckCondition()
                    );
                    stateMachine.registerCondition(
                        "hasRandom",
                        new CombinedCondition(
                            [
                                new IsInFreeSpinsCondition(),
                                new HasRandomSymbolsCondition()
                            ],
                            ConditionCombinationType.ALL
                        )
                    );
                    stateMachine.registerCondition(
                        "has_jackpot_feature",
                        new HasJackpotsFeatureCondition()
                    );
                    stateMachine.registerCondition(
                        "hasRecover",
                        new HasRecovery()
                    );
                    stateMachine.registerCondition(
                        "hasRecoverFeature",
                        new BURHasRecoverFeatureCondition()
                    );
                    stateMachine.registerCondition(
                        "hasRecoverFreeSpins",
                        new BURHasRecoverFreeSpinsCondition()
                    );
                    stateMachine.registerCondition(
                        "hasFreespins",
                        new BURHasFreeSpinsCondition()
                    );
                    stateMachine.registerCondition(
                        "hasJackpotsProgress",
                        new BURHasJackpotsProgressCondition()
                    );
                    stateMachine.startStateMachine(
                        state_config as IStatesConfigSchema
                    );
                }

                function initDefaultCommads() {
                    // The controller buttons are only hidden during free spins, which can be
                    // undone from the browser console, so the player-facing commands are
                    // also ignored here. The free spins data is set when the triggering spin
                    // result arrives and cleared at the end of the exit state, so it also
                    // covers the intro, where the UI mode is not yet FREE_SPINS.
                    const blockInFreeSpins =
                        <T extends (...args: any[]) => void>(command: T) =>
                        (...args: Parameters<T>) => {
                            if (
                                BURFeatureModel.free_spins_data ||
                                UIController.getCurrentMode() ===
                                    UIModes.FREE_SPINS
                            ) {
                                return;
                            }
                            command(...args);
                        };

                    CommandManager.setCommand(
                        Commands.SPIN,
                        blockInFreeSpins(GameCommands.SpinCommand)
                    );
                    CommandManager.setCommand(
                        Commands.CLEAR_WIN,
                        GameCommands.ClearWinFieldCommand
                    );
                    CommandManager.setCommand(
                        Commands.SKIP,
                        GameCommands.SkipCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_SPACE_TO_SPIN,
                        GameCommands.ToggleSpaceToSpinCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_TURBO_SPIN,
                        blockInFreeSpins(VendorCommands.ToggleTuboSpinCommand)
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_SPACE_TURBO_SPIN,
                        GameCommands.ToggleSpaceTuboSpinCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_LANDSCAPE_RESTRICT,
                        GameCommands.ToggleLandscapeRestrict
                    );

                    CommandManager.setCommand(
                        Commands.START_AUTOPLAY,
                        blockInFreeSpins(GameCommands.StartAutoplayCommand)
                    );
                    CommandManager.setCommand(
                        Commands.STOP_AUTOPLAY,
                        GameCommands.StopAutoplayCommand
                    );
                    CommandManager.setCommand(
                        Commands.DECREMENT_AUTOPLAY,
                        GameCommands.DecrimentAutoplay
                    );
                    CommandManager.setCommand(
                        Commands.CLEAR_AUTOPLAY_LIMITS,
                        GameCommands.ClearAutoplayLimitsCommand
                    );
                    CommandManager.setCommand(
                        Commands.SET_AUTOPLAY_LOSS_LIMIT,
                        GameCommands.SetAutoplayLossLimitCommand
                    );
                    CommandManager.setCommand(
                        Commands.SET_AUTOPLAY_SINGLE_WIN_LIMIT,
                        GameCommands.SetAutoplaySingleWinLimitCommand
                    );
                    CommandManager.setCommand(
                        Commands.SET_AUTOPLAY_TOTAL_WIN_LIMIT,
                        GameCommands.SetAutoplayTotalWinLimitCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_AUTOPLAY_STOP_ON_ANY_WIN,
                        GameCommands.ToggleAutoplayStopOnWinCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_AUTOPLAY_STOP_ON_BIG_WIN,
                        GameCommands.ToggleAutoplayStopOnBigWinCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_AUTOPLAY_STOP_ON_FEATURE_WIN,
                        GameCommands.ToggleAutoplayStopOnFeatureCommand
                    );

                    CommandManager.setCommand(
                        Commands.SHOW_ERROR,
                        GameCommands.ShowErrorPopup
                    );

                    CommandManager.setCommand(
                        Commands.CYCLE_STAKE_VALUE,
                        GameCommands.IterateStakeCommand
                    );
                    CommandManager.setCommand(
                        Commands.CYCLE_BET_VALUE,
                        blockInFreeSpins(GameCommands.IterateBetCommand)
                    );
                    CommandManager.setCommand(
                        Commands.SET_MAX_BET,
                        blockInFreeSpins(GameCommands.SetMaxBetCommand)
                    );
                    CommandManager.setCommand(
                        Commands.CYCLE_COIN_VALUE,
                        GameCommands.IterateCoinsCommand
                    );
                    CommandManager.setCommand(
                        Commands.SET_BET,
                        blockInFreeSpins((betData) => {
                            App.dispatcher.emit("BET_CHANGED", {
                                bet: betData.total
                            });
                            VendorCommands.SetBetCommand(betData);
                        })
                    );
                    CommandManager.setCommand(
                        Commands.CYCLE_TOTAL_BET,
                        blockInFreeSpins(GameCommands.IterateTotalBetCommand)
                    );
                    CommandManager.setCommand(
                        Commands.UPDATE_BALANCE,
                        GameCommands.UpdateBalanceCommand
                    );
                    CommandManager.setCommand(
                        Commands.UPDATE_WIN,
                        GameCommands.UpdateWinCommand
                    );
                    CommandManager.setCommand(
                        Commands.UPDATE_TEMP_WIN,
                        GameCommands.UpdateTempWinCommand
                    );
                    CommandManager.setCommand(
                        Commands.UPDATE_UI,
                        GameCommands.UpdateUICommand
                    );
                    CommandManager.setCommand(
                        Commands.UPDATE_FREE_SPINS,
                        GameCommands.UpdateFreeSpinsCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_SETTINGS,
                        GameCommands.ToggleSettingsCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_AUTOPLAY_SETTINGS,
                        GameCommands.ToggleAutoplaySettingsCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_BET_SETTINGS,
                        GameCommands.ToggleBetSettingsCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_PAYTABLE,
                        GameCommands.TogglePaytableCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_AUTOPLAY_POPUP,
                        blockInFreeSpins(VendorCommands.ToggleAutoplayPopupCommand)
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_BET_POPUP,
                        blockInFreeSpins(VendorCommands.ToggleBetPopupCommand)
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.TOGGLE_SOUND_CONTROLLER,
                        VendorCommands.ToggleSoundPopupCommand
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.TOGGLE_SOUND_BUTTON,
                        VendorCommands.ToggleSoundButtonCommand
                    );

                    CommandManager.setCommand(
                        Commands.TOGGLE_SOUND_FX,
                        GameCommands.ToggleSoundFXCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_MUSIC,
                        GameCommands.ToggleMusicCommand
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.UPDATE_JACKPOTS,
                        VendorCommands.UpdateJackpotsCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_MASTER_SOUND,
                        GameCommands.ToggleMasterSoundCommand
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.TOGGLE_JACKPOTS_BUTTON,
                        VendorCommands.ToggleJackpotBtnCommand
                    );
                    CommandManager.setCommand(
                        Commands.SET_MASTER_VOLUME,
                        GameCommands.SetMasterVolumeCommand
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.SHOW_INSUFFICIENT_FUNDS_MESSAGE,
                        VendorCommands.ShowInsufficientFoundsDialog
                    );
                    CommandManager.setCommand(
                        Commands.GO_HOME,
                        VendorCommands.GoHome
                    );
                    CommandManager.setCommand(
                        Commands.CLOSE_SETTINGS,
                        GameCommands.CloseSettingsCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_CURSOR,
                        GameCommands.ToggleCursorCommand
                    );
                    CommandManager.setCommand(
                        Commands.UPDATE_CASCADE_HISTORY,
                        GameCommands.UpdateCascadeHistory
                    );

                    CommandManager.setCommand(
                        Commands.CLEAR_CASCADE_HISTORY,
                        GameCommands.ClearCascadeHistory
                    );
                    // TODO set the rest of them :)
                }

                function setUpUIComponents() {
                    UIController.setComponent(
                        "main",
                        InstanceFactory.getClass("UIView")
                    );
                    UIController.setComponent(
                        "settings",
                        InstanceFactory.getClass("Settings")
                    );
                    // UIController.setComponent("betPopup", new BetPopup()); //* lemmy - Is it necessary to remove this?
                    // UIController.setComponent("autoplayPopup", new AutoplayPopup()); //* lemmy - Is it necessary to remove this?
                    // UIController.setComponent("soundPopup", new SoundPopup()); //* lemmy - Is it necessary to remove this?
                    UIController.setComponent(
                        "messagePopup",
                        new MessagePopup()
                    );
                    CommandManager.setCommand(
                        Commands.REQUEST_HISTORY,
                        VendorCommands.showHistory
                    );
                    UIController.setComponent("errorPopup", new ErrorPopup());
                    UIController.setComponent(
                        "insufficientFundsPopup",
                        new InsufficientPopup()
                    );
                }
            }
        );
    });

    // Populate requests
    // };
};
window.onload = () => {
    start({ config: game_config, gameFactory: new GameFactory() });
};
